import React from 'react';
import { Link } from 'react-router-dom';
import SEOHead from '../components/SEOHead';

const NotFound: React.FC = () => {
  return (
    <article className="pt-24 pb-16 bg-neutral-offwhite min-h-[60vh] flex items-center">
      <SEOHead title="Page introuvable" path="/404" noindex />
      <div className="container mx-auto px-4 text-center">
        <h1 className="font-playfair text-6xl md:text-8xl font-bold text-brand mb-6">404</h1>
        <h2 className="font-playfair text-2xl md:text-3xl font-bold text-neutral-ink mb-4">
          Page introuvable
        </h2>
        <p className="font-nunito text-neutral-body text-lg mb-8 max-w-md mx-auto">
          La page que vous recherchez n'existe pas ou a été déplacée.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 bg-brand text-white font-nunito font-semibold px-6 py-3 rounded-full hover:bg-brand-dark transition-colors duration-300"
        >
          Retour à l'accueil
        </Link>
      </div>
    </article>
  );
};

export default NotFound;
